import { FC } from 'react';
import { SessionContainerProps } from '../config';
import { observer } from 'mobx-react';

const _ContainDefault: FC<SessionContainerProps> = ({
  onNext,
  onFinish,
  children,
}) => {
  return children({
    onNext,
    onFinish
  });
};

export const ContainDefault = observer(_ContainDefault);
